<mat-dialog-content class="mat-typography p-12" appPerfectScrollbar fxLayoutAlign="center center">
    <mat-spinner [diameter]="30"></mat-spinner>
</mat-dialog-content>